<div [ngClass]="{'chart-option-selected': option.selected}" class="chart-option">
    <fui-icon [height]="24" [icon]="option.icon" [width]="24"></fui-icon>
</div>
